package com.vizio.redwolf.utils

import kotlin.Boolean
import kotlin.String

public object BuildConfig {
  public const val SDK_VERSION: String = "9.11.0-BUILD-SNAPSHOT"

  public const val SERVICES_TEST_ENV: String =
      """{"default":"stage","auth":"stage","consent":"stage","developer":"stage","dms":"stage","ecommerce":"stage","gram":"stage","pay_setup":"stage","purchase_pin":"stage","pii":
      "stage","analytics": "stage","mfa": "stage","beta_sign_up": "stage","apps": "stage","alexa":
      "dev","guide": "stage","passwordless_auth": "stage","mobileChannels": "dev","clips":
      "dev","avod": "stage","m2m": "stage","identityProxy": "stage","notifications":
      "stage","offers": "stage","watchlist": "stage"}"""

  public const val IGNORE_CORS_FAILURES: Boolean = false

  public const val VIZIO_REDWOLF_CI_CD: String = "vizio-redwolf-ci-cd"

  public val AGENT_RW_CI_CD: String? = null
}
